import { profilesApi } from '@/api';
import { useToast } from '@/store/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ErrorNotificationIcon, SuccessNotificationIcon } from '@/assets/icons';
import { useTranslation } from 'react-i18next';

export const useBlockedProfileById = () => {
    const queryClient = useQueryClient();

    const showToast = useToast((state) => state.show);

    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: profilesApi.blockProfileById,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profiles'] });
            showToast({
                // type success
                icon: <SuccessNotificationIcon />,
                msg: t('msgs.profile_success_blocked')
            });
        },
        onError: (error) => {
            console.error('Error blocked profile:', error);
            showToast({
                // type error
                icon: <ErrorNotificationIcon />,
                msg: t('msgs.profile_fail_blocked')
            });
        },
    });

    return mutation;
};
